module.exports = __webpack_public_path__ + "static/media/city.c0219567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/city.jpg
// module id = 752
// module chunks = 1 3